module.exports = __webpack_public_path__ + "images/img_IP_4-51e88b947c.png";